import { Box, Button, Flex, Input, Option, Select, Text } from '@modusign/design-system';

import { Survey } from '@app/containers/Modal/WelcomeSurveyModal';
import { PURPOSES } from '@app/containers/Modal/WelcomeSurveyModal/fixtures';

const MAX_PURPOSE_LENGTH = 100;

interface PurposeStepProps {
  nextStep: () => void;
  survey: Survey;
  setSurvey: (update: (survey: Survey) => Survey) => void;
}

function PurposeStep({ nextStep, survey, setSurvey }: PurposeStepProps) {
  const isFormValid =
    !!survey.purpose &&
    (survey.purpose !== '기타' || !!survey.purposeExtra) &&
    survey.purpose.length <= MAX_PURPOSE_LENGTH;

  return (
    <>
      <Box fontSize={2} fontWeight="medium" mt={2}>
        입력하신 정보에 맞는 모두싸인으로 설정해 드릴게요.
      </Box>
      <Box mt={8}>
        <Box>
          <Text fontWeight="medium">가입 목적</Text>
        </Box>
        <Box mt={3}>
          <Select
            color={survey.purpose ? undefined : 'textNeutralVeryLight'}
            height="44px"
            required
            value={survey.purpose}
            onChange={({ currentTarget }) =>
              setSurvey((prev) => ({ ...prev, purpose: currentTarget.value }))
            }
          >
            <Option disabled value="">
              가입 목적을 선택해 주세요.
            </Option>
            {PURPOSES.map((value) => (
              <Option key={value}>{value}</Option>
            ))}
          </Select>
          {survey.purpose === '기타' && (
            <Input
              height="44px"
              maxLength={100}
              minLength={1}
              mt={2}
              placeholder="기타 가입 목적을 입력해 주세요."
              required
              value={survey.purposeExtra}
              onChange={({ currentTarget }) =>
                setSurvey((prev) => ({ ...prev, purposeExtra: currentTarget.value }))
              }
            />
          )}
        </Box>
        <Flex alignItems="center" justifyContent="end" mt={9}>
          <Button disabled={!isFormValid} ml={6} variant="primary" onClick={nextStep}>
            다음
          </Button>
        </Flex>
      </Box>
    </>
  );
}

export default PurposeStep;
